/**
 * RequireCustomerAuth — wraps a portal subtree and bounces the visitor to
 * `/auth/login` when no usable customer JWT is present in localStorage.
 *
 * Mirrors the staff app's `RequireAuth` pattern: the redirect carries a
 * `from` location in state so post-login UX can return them to the page they
 * tried to open. (Phase 1c will surface that — for now we just send them to
 * the dashboard after login.)
 */
import type { JSX, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useCustomerAuth } from './useCustomerAuth';

interface RequireCustomerAuthProps {
  readonly children: ReactNode;
}

export function RequireCustomerAuth({ children }: RequireCustomerAuthProps): JSX.Element {
  const { isAuthenticated } = useCustomerAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/auth/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
}
